module.exports = __webpack_public_path__ + "img/guests.326b3d67.svg";